module.exports = __webpack_public_path__ + "static/media/2_exp_complete.a9aeee53.png";